import loadDemoAndFocus from '{src}/javascripts/main/loadDemoAndFocus.ts'

async function loadDemo() {
  await import('./uppy-homepage-demo.ts')
}

loadDemoAndFocus('a[href="#uppy-try"]', loadDemo, '.uppy-Dashboard-browse')
